import { ConfigType } from './config-type.enum';
import { JsonObject, JsonProperty } from 'json2typescript';

import { AbstractEntity } from '../../abstract-entity/abstract-entity';
import { ActivityDefaultLearnCertConfigItem } from './activity-default-learn-cert-config-item';
import { ArchiveDefaultLearnCertConfigItem } from './archive-default-learn-cert-config-item';

@JsonObject
export class DefaultLearnCertConfig extends AbstractEntity {
  @JsonProperty('tenantId', Number)
  tenantId: number = undefined;

  @JsonProperty('name', String)
  name: string = undefined;

  @JsonProperty('type', String)
  type: ConfigType;

  @JsonProperty('deptIds', [Number])
  deptIds: number[] = [];

  @JsonProperty('groupIds', [Number])
  groupIds: number[] = [];

  @JsonProperty('activityConfigItems', [ActivityDefaultLearnCertConfigItem])
  activityConfigItems: ActivityDefaultLearnCertConfigItem[] = [];

  @JsonProperty('archiveConfigItems', [ArchiveDefaultLearnCertConfigItem])
  archiveConfigItems: ArchiveDefaultLearnCertConfigItem[] = [];
}
